import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { firstValueFrom, throwError } from 'rxjs';
import { UsuarioModel } from '../sso/models/usuario.model';
import { IdiomaModel } from '../sso/models/idioma.model';
import { TextoModel } from '../sso/models/texto.model';
import { environment } from '../../../environments/environment';
import { RolModel } from '../sso/models/rol.model';
import { EmpresaModel } from '../sso/models/empresa.model';
import { AplicacionModel } from '../sso/models/aplicacion.model';
import {
  PermisoModel,
  RolMenuOpcionesModel,
} from '../sso/models/rol.menu.opciones.model';
import { ApartadoAppPermisoModel } from '../sso/models/apartado.app.permiso.model';

@Injectable({
  providedIn: 'root',
})
export class CrudService {
  REST_API = environment.apiSSO;

  constructor(private http: HttpClient) {}

  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  //USUARIOS-----------------------------------------------------------------------------------
  //get usuarios
  async getUsers(): Promise<UsuarioModel[]> {
    let result: UsuarioModel[] = null;
    try {
      result = await this.http
        .get<UsuarioModel[]>(`${this.REST_API}/sso/usuarios`)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }

  //get Usuario
  async getUserPorId(id: string): Promise<UsuarioModel> {
    let result: UsuarioModel = null;
    try {
      result = await this.http
        .get<UsuarioModel>(`${this.REST_API}/sso/usuario/${id}`)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }

  //CREAR usuario
  async addUser(usuario: UsuarioForm): Promise<UsuarioModel> {
    let response: UsuarioModel = null;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    try {
      response = await this.http
        .post<UsuarioModel>(
          `${this.REST_API}/sso/usuario/crear`,
          JSON.stringify(usuario),
          httpOptions,
        )
        .toPromise();
    } catch (e) {
      window.alert(e.error.error);
    }
    return response;
  }

  //EDITAR USUARIO
  async editUser(usuario: UsuarioForm): Promise<UsuarioForm> {
    let response: UsuarioForm;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    try {
      response = await this.http
        .post<UsuarioForm>(
          `${this.REST_API}/sso/usuario/modificar/todo`,
          JSON.stringify(usuario),
          httpOptions,
        )
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return response;
  }

  //EDITAR CONTRASEÑA USUARIO
  async editPassUser(passUser): Promise<any> {
    let response: any;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    try {
      response = await this.http
        .post<any>(
          `${this.REST_API}/sso/usuario/modificapassw`,
          JSON.stringify(passUser),
          httpOptions,
        )
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return response;
  }

  //BORRAR USUARIO
  async deleteUsuario(id: number) {
    let response;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    try {
      response = await this.http
        .delete(`${this.REST_API}/sso/usuario/borrar/${id}`, httpOptions)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return response;
  }

  //IDIOMAS-----------------------------------------------------------------------------------
  //get idiomas
  async getIdiomas(): Promise<IdiomaModel[]> {
    let result: IdiomaModel[] = null;
    try {
      result = await this.http
        .get<IdiomaModel[]>(`${this.REST_API}/sso/idiomas`)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }

  //CREAR O MODIFICAR idioma
  async addEditIdioma(idioma): Promise<IdiomaModel> {
    let response: IdiomaModel = null;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    try {
      response = await this.http
        .post<IdiomaModel>(
          `${this.REST_API}/sso/idioma/crear`,
          JSON.stringify(idioma),
          httpOptions,
        )
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return response;
  }

  //BORRAR IDIOMA
  async deleteIdioma(id: number) {
    let response;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    try {
      response = await this.http
        .delete(`${this.REST_API}/sso/idioma/borrar/${id}`, httpOptions)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return response;
  }

  //TEXTOS-----------------------------------------------------------------------------------
  //get textos
  async getTextos(id): Promise<TextoModel[]> {
    let result: TextoModel[] = null;
    try {
      result = await this.http
        .get<TextoModel[]>(`${this.REST_API}/sso/textos/${id}`)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }

  //get textos
  async getAllTextos(): Promise<TextoModel[]> {
    let result: TextoModel[] = null;
    try {
      result = await this.http
        .get<TextoModel[]>(`${this.REST_API}/sso/textos`)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }

  //CREAR O MODIFICAR texto desde el form
  async addEditText(text): Promise<TextoModel> {
    let response: TextoModel = null;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    try {
      response = await this.http
        .post<TextoModel>(
          `${this.REST_API}/sso/texto/crear`,
          JSON.stringify(text),
          httpOptions,
        )
        .toPromise();
    } catch (e) {
      console.log(e);
      if (e.error.error.includes('Duplicate entry')) {
        alert(
          `Ya existe el texto '${text.Texto}'. No se aplicará ningún cambio`,
        );
      }
    }
    return response;
  }

  //CREAR O MODIFICAR texto desde el campo
  async editText(text): Promise<TextoModel> {
    let response: TextoModel = null;
    let id = text.IdiomaId;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    try {
      if (id) {
        response = await this.http
          .post<TextoModel>(
            `${this.REST_API}/sso/texto/idioma/crear`,
            JSON.stringify(text),
            httpOptions,
          )
          .toPromise();
      } else {
        response = await this.http
          .post<TextoModel>(
            `${this.REST_API}/sso/texto/crear`,
            JSON.stringify(text),
            httpOptions,
          )
          .toPromise();
      }
    } catch (e) {
      console.log(e);
    }
    return response;
  }

  //BORRAR texto
  async deleteTexto(textId: any, idiomaID: any) {
    let response;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    try {
      if (idiomaID != 1) {
        response = await this.http
          .delete(
            `${this.REST_API}/sso/texto/idioma/borrar/${idiomaID}/${textId}`,
            httpOptions,
          )
          .toPromise();
      } else {
        response = await this.http
          .delete(`${this.REST_API}/sso/texto/borrar/${textId}`, httpOptions)
          .toPromise();
      }
    } catch (e) {
      console.log(e);
    }
    return response;
  }

  //ROLES-------------------------------------------------------------------------------------------------------------------------------
  //Get Roles
  async getRoles(): Promise<RolModel[]> {
    let result: RolModel[] = null;

    try {
      result = await this.http
        .get<RolModel[]>(`${this.REST_API}/sso/roles`)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }

  // Recupera las aplicaciones de un rol
  async getAppsRoles(rol: number): Promise<AplicacionModel[]> {
    let result: AplicacionModel[];
    try {
      result = await this.http
        .get<
          AplicacionModel[]
        >(`${this.REST_API}/sso/roles/aplicaciones/${rol}`)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result ? result : [];
  }

  // Recupera los roles de una aplicacion
  async getRolesApp(app: number): Promise<RolModel[]> {
    let result: RolModel[];
    try {
      result = await firstValueFrom(
        this.http.get<RolModel[]>(
          `${this.REST_API}/sso/aplicacion/roles/${app}`,
        ),
      );
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result ? result : [];
  }

  //CREAR O MODIFICAR rol
  async addEditRol(rol): Promise<Number> {
    let response;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    try {
      response = await this.http
        .post<RolModel>(
          `${this.REST_API}/sso/rol/crear`,
          JSON.stringify(rol),
          httpOptions,
        )
        .toPromise();
    } catch (e) {
      console.log(e);
    }
    return response;
  }

  //Borrar Rol
  async deleteRol(rolId) {
    let result;

    try {
      result = await this.http
        .delete(`${this.REST_API}/sso/rol/borrar/${rolId}`)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }

  //EMPRESAS-------------------------------------------------------------------------------------------------------------------------------
  //Get Empresas
  async getEmpresas(): Promise<EmpresaModel[]> {
    let result: EmpresaModel[] = null;

    try {
      result = await this.http
        .get<EmpresaModel[]>(`${this.REST_API}/sso/empresas`)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }

  //APLICACIONES-------------------------------------------------------------------------------------------------------------------------------
  //Get Aplicaciones
  async getApps(): Promise<AplicacionModel[]> {
    let result: AplicacionModel[] = null;

    try {
      result = await firstValueFrom(
        this.http.get<AplicacionModel[]>(`${this.REST_API}/sso/aplicaciones`),
      );
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }

  //Get Aplicaciones por Empresa
  async getAppsBusiness(id): Promise<AplicacionModel[]> {
    let result: AplicacionModel[] = null;

    try {
      result = await this.http
        .get<
          AplicacionModel[]
        >(`${this.REST_API}/sso/aplicaciones/empresa/${id}`)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }

  //Get Usuarios por Empresa
  async getUsersBusiness(id): Promise<UsuarioModel[]> {
    let result: UsuarioModel[] = null;

    try {
      result = await this.http
        .get<UsuarioModel[]>(`${this.REST_API}/sso/empresa/usuarios/${id}`)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }

  //Get Empresa por Id
  async getAllBusinessById(empresas): Promise<any> {
    let result: any[] = [];

    try {
      for (let i = 0; i < empresas.length; i++) {
        let empresa = await this.http
          .get<any>(
            `${this.REST_API}/sso/empresa/aplicaciones/${empresas[i].Id}`,
          )
          .toPromise();

        empresa.forEach((registro) => {
          result.push(registro);
        });
      }
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }

  //ACCESOS----------------------------------------------------------------------------------------------------------------
  //Añadir acceso
  async addAccess(access): Promise<Number> {
    let response;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    try {
      response = await this.http
        .post<RolModel>(
          `${this.REST_API}/sso/usuario/crearacceso`,
          JSON.stringify(access),
          httpOptions,
        )
        .toPromise();
    } catch (e) {
      console.log(e);
    }
    return response;
  }

  //Borrar Acceso
  async delAccess(accessId) {
    let result;

    try {
      result = await this.http
        .delete(`${this.REST_API}/sso/usuario/borraacceso/${accessId}`)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }
  //REGISTROS----------------------------------------------------------------------------------------------------------------
  //Añadir/Modificar registro
  async addEditAppBusiness(appUrl): Promise<any> {
    let response;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    try {
      response = await this.http
        .post<any>(
          `${this.REST_API}/sso/aplicacion/empresa/crear`,
          JSON.stringify(appUrl),
          httpOptions,
        )
        .toPromise();
    } catch (e) {
      console.log(e);
    }
    return response;
  }
  //Borrar Registro
  async delAppBussines(registroId) {
    let result;

    try {
      result = await this.http
        .delete(`${this.REST_API}/sso/aplicacion/empresa/borrar/${registroId}`)
        .toPromise();
    } catch (e) {
      console.log(e);
      window.alert(e.error.error);
    }
    return result;
  }
  //DOBLE FACTOR----------------------------------------------------------------------------------------------------------------
  //Añadir Doble Factor
  async addDF(UsuarioLogin): Promise<any> {
    let response;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    try {
      response = await this.http
        .post<any>(
          `${this.REST_API}/sso/usuario/generadfcodigo`,
          JSON.stringify(UsuarioLogin),
          httpOptions,
        )
        .toPromise();
    } catch (e) {
      console.log(e);
    }
    return response;
  }

  //Editar Doble Factor
  async editDF(Usuario): Promise<any> {
    let response;
    if (Usuario.UsuarioEmail) {
      Usuario['UsuarioLogin'] = Usuario.UsuarioEmail;
      delete Usuario['UsuarioEmail'];
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    try {
      response = await this.http
        .post<any>(
          `${this.REST_API}/sso/usuario/modificadf`,
          JSON.stringify(Usuario),
          httpOptions,
        )
        .toPromise();
    } catch (e) {
      console.log(e);
    }
    return response;
  }

  async getMenuOptionsRol(
    rolId: number,
    appId: number,
  ): Promise<RolMenuOpcionesModel[]> {
    try {
      return await firstValueFrom(
        this.http.get<RolMenuOpcionesModel[]>(
          `${this.REST_API}/sso/menu/opciones/rol/${rolId}/${appId}`,
        ),
      );
    } catch (e) {
      console.log(e);
    }
    return [];
  }

  async saveMenuOptionsRol(options: RolMenuOpcionesModel[]): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    try {
      return await this.http
        .post<any>(
          `${this.REST_API}/sso/menu/opciones/rol`,
          JSON.stringify(options),
          httpOptions,
        )
        .toPromise();
    } catch (e) {
      console.log(e);
    }
    return null;
  }

  async getPermisos(): Promise<PermisoModel[]> {
    try {
      return await firstValueFrom(
        this.http.get<PermisoModel[]>(`${this.REST_API}/sso/usuarios/permisos`),
      );
    } catch (e) {
      console.log(e);
    }
    return [];
  }

  async saveApartadoAppPermisos(
    permisos: ApartadoAppPermisoModel[],
  ): Promise<boolean> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    try {
      return await this.http
        .post<any>(
          `${this.REST_API}/sso/apartados/permisos`,
          JSON.stringify(permisos),
          httpOptions,
        )
        .toPromise();
    } catch (e) {
      console.log(e);
    }
    return false;
  }

  getMenuByApplication(appId: number): Promise<any> {
    try {
      return firstValueFrom(
        this.http.get<any>(`${this.REST_API}/sso/menus?aplicacion=${appId}`),
      );
    } catch (e) {
      console.log(e);
    }
    return null;
  }

  getOpctionsWithPermisionsByMenu(menuId: number, appId: number): Promise<any> {
    try {
      return firstValueFrom(
        this.http.get<any>(
          `${this.REST_API}/sso/menu/permisos/opciones/lista?aplicacionId=${appId}&menuId=${menuId}`,
        ),
      );
    } catch (e) {
      console.log(e);
    }
  }

  getMenuPermissionsByOption(
    appId: number,
    menuId: number,
    menuOpcionId: number,
  ): Promise<any> {
    try {
      return firstValueFrom(
        this.http.get<any>(
          `${this.REST_API}/sso/menu/permisos?aplicacionId=${appId}&menuId=${menuId}&menuOpcionId=${menuOpcionId}`,
        ),
      );
    } catch (e) {
      console.log(e);
    }
    return null;
  }

  saveMenuPermissionsByOptions(payload: {
    appId: number;
    menuId: number;
    menuOpcionIds: number[];
    permisos: { IdRol: number; IdPermiso: number }[];
  }): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    const payloadToSend = {
      aplicacionId: payload.appId,

      menuId: payload.menuId,

      idMenuOpcion: payload.menuOpcionIds,
      permisos: payload.permisos,
    };
    try {
      return firstValueFrom(
        this.http.post<any>(
          `${this.REST_API}/sso/menu/permisos`,
          JSON.stringify(payloadToSend),
          httpOptions,
        ),
      );
    } catch (e) {
      console.log(e);
    }
  }
}

export interface UsuarioForm {
  id?: string;
  UsuarioEmail?: string;
  UsuarioLogin?: string;
  UsuarioPassword?: any;
  UsuarioNombre: string;
  UsuarioImagen?: string;
  UsuarioIdioma?: number;
  IdiomaId?: number;
  UrlWeb?: string;
  UsuarioActivo: boolean;
  UsuarioValidado?: boolean;
}
